<template>
  <div
    class="loader"
    :style="{
      width: `${size}px`
    }"
  >
    <span
      :style="{
        width: `${size}px`,
        height: `${size}px`
      }"
      class="loader-anim"
    />
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 60
    }
  }
};
</script>

<style lang="scss" scoped>
.loader {
  @include margin(null auto);
  position: relative;

  @keyframes loading {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  &-anim {
    display: block;
    animation: loading 1s infinite linear;
    border-radius: 50%;
    border: 5px solid rgba($grey, .3);
    border-top-color: $primary;
  }
}
</style>
